<template>
  <swiper
    :modules="modules"
    :slides-per-view="1"
    :space-between="50"
    :navigation="navigation"
    :breakpoints="breakpoints"
    :pagination="{ 
        clickable: true, 
        el: paginationSelector,
    }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <slot></slot>
  </swiper>
</template>

<style>

:root {
  --swiper-theme-color: theme('colors.light');
  --swiper-pagination-bullet-size: 18px;
  --swiper-pagination-color: theme('colors.red');
}
/* :root {  
  --swiper-pagination-bullet-width: 8px;
  --swiper-pagination-bullet-height: 8px;
  --swiper-pagination-bullet-inactive-color: #000;
  --swiper-pagination-bullet-inactive-opacity: 0.2;
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-bullet-horizontal-gap: 4px;
  --swiper-pagination-bullet-vertical-gap: 6px;
} */
.swiper-pagination {
  @apply space-x-3;
}

.swiper-pagination-bullet {
  @apply inline-block rounded-full bg-light w-[18px] h-[18px];
}

.swiper-pagination-bullet.swiper-pagination-bullet-active {
  @apply bg-primary;
}
</style>

<script>
  // Import Swiper Vue.js components
  import { Navigation, Pagination, A11y } from 'swiper';
  import { Swiper, SwiperSlide } from 'swiper/vue';

  // Import Swiper styles
  import 'swiper/css';
  import 'swiper/css/navigation';
  import 'swiper/css/scrollbar';

  export default {
    components: {
      Swiper,
      SwiperSlide,
    },

    props: {
      paginationSelector: {
        type: String,
        default: '.swiper-pagination',
      },
      navigation: {
          type: Boolean,
          default: false,
      },
      breakpoints: {
          type: Object,
          default: false,
      }
    },

    setup() {
      const onSwiper = (swiper) => {
        console.log(swiper);
      };
      const onSlideChange = () => {
        console.log('slide change');
      };

      return {
        onSwiper,
        onSlideChange,
        modules: [Navigation, Pagination, A11y],
      };
    },
  };
</script>